import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import ScrollToTopOnNavigate from './utils/scroll'
import Landing from './pages/landing'
import Privacy from './pages/privacy'
import Terms from './pages/terms'
import Cookies from './pages/cookies'
import Contact from './pages/contact'
import 'react-toastify/dist/ReactToastify.css'
import COPY from './utils/copy'
import { WindowWidthProvider } from './context/window'

export default function App() {
  return (
    <WindowWidthProvider>
      <Router>
        <Routes>
          <Route path={COPY.HOME_URL} element={<Landing />} />
          <Route path={COPY.PRIVACY_URL} element={<Privacy />} />
          <Route path={COPY.TERMS_URL} element={<Terms />} />
          <Route path={COPY.COOKIES_URL} element={<Cookies />} />
          <Route path={COPY.CONTACT_URL} element={<Contact />} />
          <Route path='*' element={<Landing />} />
        </Routes>
        <ToastContainer />
        <ScrollToTopOnNavigate />
      </Router>
    </WindowWidthProvider>
  )
}
